// @ts-nocheck
import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('show', () => this.renderGroupedCart());
    this.#setupCheckoutHandling();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#cleanupCheckoutHandling();
  }

  #setupCheckoutHandling() {
    this.addEventListener('click', this.#handleCheckoutClick);
  }

  #cleanupCheckoutHandling() {
    this.removeEventListener('click', this.#handleCheckoutClick);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleCheckoutClick = (e) => {
    const btn = e.target?.closest?.('#checkout');
    if (!btn || btn.disabled) return;
    
    const form = this.querySelector('form[action="/checkout"]') || 
                 document.querySelector('form[action="/checkout"]');
    if (form) {
      form.submit();
    } else {
      window.location.href = '/checkout';
    }
  };

  open() {
    this.showDialog();
    this.renderGroupedCart();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  async renderGroupedCart(passedCart = null) {
    try {
      // Asegurar que el mapa global de colores fotocromáticos esté cargado
      await (async function ensurePhotocromaticColorsLoaded() {
        if (typeof window === 'undefined') return;
        if (window.PHOTOCROMATIC_COLOR_MAP && window.PHOTOCROMATIC_COLOR_LABEL) return;
        // Si ya hay un script marcado como cargando, esperar su evento
        const existing = document.querySelector('script[data-photocromatic-colors]');
        if (existing) {
          await new Promise((resolve) => { existing.addEventListener('load', () => resolve(), { once: true }); setTimeout(resolve, 600); });
          return;
        }
        // Intentar inyectar el asset desde /assets/photocromatic-colors.js
        try {
          const script = document.createElement('script');
          script.src = '/assets/photocromatic-colors.js';
          script.async = false;
          script.setAttribute('data-photocromatic-colors', '1');
          document.head.appendChild(script);
          await new Promise((resolve) => { script.addEventListener('load', resolve, { once: true }); setTimeout(resolve, 800); });
        } catch (e) {
          // fallback silencioso
        }
      })();

      const container = this.querySelector('.cart-drawer__items') || document.querySelector('.cart-drawer__items');
      if (!container) return;
  const cart = passedCart || (await (async () => { const resp = await fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }); if (!resp.ok) return null; return await resp.json(); })());
  if (!cart) return;

      const normalizeProps = (item) => {
        if (!item.properties) return {};
        if (Array.isArray(item.properties)) {
          const o = {};
          item.properties.forEach(p => { if (p?.name) o[p.name] = p.value; });
          return o;
        }
        return item.properties || {};
      };

      const groups = new Map();
      cart.items.forEach(item => {
        const props = normalizeProps(item);
        const groupId = props._p_groupId || item.key || `single-${item.key}`;
        if (!groups.has(groupId)) groups.set(groupId, []);
        groups.get(groupId).push({ item, props });
      });

      const groupsHtml = [];
      
      // Calcular precio total por grupo
      const calculateGroupTotal = (members) => {
        return members.reduce((total, member) => {
          const price = member.item.final_price ?? member.item.original_price ?? member.item.price ?? 0;
          return total + (price * (member.item.quantity || 1));
        }, 0);
      };

      groups.forEach((members, groupId) => {
        // Debug: imprimir miembros y props si se activa el flag global
        try { if (typeof window !== 'undefined' && window.LENS_DEBUG) console.debug('[LENS DEBUG] group', groupId, members.map(m => ({ key: m.item.key, title: m.item.title || m.item.product_title, props: m.props }))); } catch(e) {}
        let main = members.find(m => m.props?._p_productType === 'main') || members[0];
        const addons = members.filter(m => m !== main);

        const title = main.item.product_title || main.item.title || main.item.product?.title || 'Producto';
        const qty = main.item.quantity || 1;
        const groupTotal = calculateGroupTotal(members);
        const imgSrc = main.item.image || main.item.variant?.image || '';
        const imageHtml = imgSrc ? `<div class="grouped-cart-item__thumb"><img src="${imgSrc}" alt="${title}" loading="lazy"/></div>` : '';

        let html = `
          <div class="grouped-cart-item" data-group-id="${groupId}">
            <div class="grouped-cart-item__main">
              ${imageHtml}
              <div class="grouped-cart-item__title-wrap">
                <div class="grouped-cart-item__title">${title}</div>
                <div class="grouped-cart-item__meta">
                  Cantidad: ${qty} · ${(groupTotal / 100).toFixed(2)} €
                </div>
              </div>
              <button class="grouped-cart-item__remove" data-group-id="${groupId}" aria-label="Eliminar producto">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path class="remove-icon-bottom" d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
                  <path class="remove-icon-top" d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
        `;

        // Solo mostrar addons si existen
        if (addons.length > 0) {
          html += `<div class="grouped-cart-item__details">`;
          html += `<div class="grouped-cart-item__addons">`;
          html += `<div class="addons-title">Incluye:</div>`;
          html += `<div class="addons-list">`;
          
          addons.forEach(a => {
            const addonTitle = a.item.product_title || a.item.title || 'Producto adicional';
            const addonPrice = (a.item.final_price ?? a.item.original_price ?? a.item.price ?? 0) / 100;
            const addonQty = a.item.quantity || 1;
            
            // Buscar propiedades descriptivas del addon
            const addonProps = a.props || {};
            const descriptiveProps = ['_tipo', '_material', '_tratamiento', '_lente', '_montura', '_tratamientos'];
            let description = '';
            
            for (const prop of descriptiveProps) {
              if (addonProps[prop]) {
                description = addonProps[prop];
                break;
              }
            }
            
            // Determinar si este addon corresponde a las lentes de lectura
            const addonLowerTitle = (addonTitle || '').toString().toLowerCase();
            const tipoProp = (addonProps && (addonProps['_tipo'] || addonProps['_p_addonType'] || addonProps['_tratamiento'])) || '';
            const tipoLower = String(tipoProp).toLowerCase();
            const isLensAddon = tipoLower.includes('lens') || tipoLower.includes('lente') || tipoLower.includes('lectura') || addonLowerTitle.includes('lectura') || addonLowerTitle.includes('reading');

            // Mostrar magnificación SOLO si este addon es el de lentes/lectura
            const findMagnification = () => {
              if (!isLensAddon) return null;
              // Buscar en varias claves posibles: técnica y legible, con y sin tilde
              const keys = ['_magnification', 'Graduación', 'Graduacion', 'graduacion'];
              for (const k of keys) {
                if (addonProps && addonProps[k] !== undefined && addonProps[k] !== null && String(addonProps[k]).trim() !== '') return String(addonProps[k]).trim();
              }
              // Fallback a las props del main del grupo
              if (main && main.props) {
                for (const k of keys) {
                  if (main.props[k] !== undefined && main.props[k] !== null && String(main.props[k]).trim() !== '') return String(main.props[k]).trim();
                }
              }
              return null;
            };

            const rawMag = findMagnification();
            const normalizeMag = (m) => {
              if (!m) return null;
              const s = String(m).trim();
              return s.startsWith('+') ? s.slice(1) : s;
            };

            const mag = normalizeMag(rawMag);
            const displayName = description ? `${description}${mag ? ` (${mag})` : ''}` : `${addonTitle}${mag ? ` (${mag})` : ''}`;

            // Solo mostrar color si el addon corresponde al tratamiento fotocromático
            const possibleColorKeys = ['photocromatic_color', '_photocromatic_color', 'photocromatic', '_tratamientos_color'];
            let detectedColor = null;

            // Detectar si este addon es el tratamiento fotocromático por su propiedad descriptiva o título
            const addonLower = (addonProps['_tratamiento'] || addonTitle || '').toString().toLowerCase();
            const isPhotocromaticLine = addonLower.includes('photocrom') || addonLower.includes('fotocrom') || addonLower.includes('fotocromático') || addonTitle.toString().toLowerCase().includes('fotocrom');

            if (isPhotocromaticLine) {
              // Priorizar propiedades del propio addon
              for (const k of possibleColorKeys) {
                if (addonProps[k]) {
                  detectedColor = String(addonProps[k]).toLowerCase();
                  break;
                }
              }

              // Fallback: si addon no incluye color, comprobar propiedades del main del grupo
              try {
                if (!detectedColor && main && main.props) {
                  for (const k of possibleColorKeys) {
                    if (main.props[k]) { detectedColor = String(main.props[k]).toLowerCase(); break; }
                  }
                  // También intentar dentro de main.props['_tratamientos']
                  if (!detectedColor && main.props['_tratamientos']) {
                    const rawMain = String(main.props['_tratamientos']).toLowerCase();
                    if (rawMain.includes('photocromatic') || rawMain.includes('fotocrom')) {
                      if (rawMain.includes('verde')) detectedColor = 'verde';
                      else if (rawMain.includes('marr') || rawMain.includes('marrón') || rawMain.includes('marron')) detectedColor = 'marron';
                      else if (rawMain.includes('gris')) detectedColor = 'gris';
                    }
                  }
                }
              } catch (e) {}

              // Si no lo encontramos como clave directa, intentar buscar dentro de _tratamientos o _tratamiento del addon
              if (!detectedColor && addonProps['_tratamientos']) {
                const raw = String(addonProps['_tratamientos']).toLowerCase();
                if (raw.includes('photocromatic') || raw.includes('fotocrom')) {
                  if (raw.includes('verde')) detectedColor = 'verde';
                  else if (raw.includes('marr') || raw.includes('marrón') || raw.includes('marron')) detectedColor = 'marron';
                  else if (raw.includes('gris')) detectedColor = 'gris';
                }
              }
            }

            // Mapear etiquetas a colores reales (solo si isPhotocromaticLine)
            // Use any globals provided by the shared asset, but ensure robust inline defaults
            const DEFAULT_PHOTOCROMATIC_MAP = { verde: '#2ecc71', marron: '#8b5e3c', gris: '#6b7280' };
            const DEFAULT_PHOTOCROMATIC_LABEL = { verde: 'Verde', marron: 'Marrón', gris: 'Gris' };
            const GLOBAL_COLOR_MAP = (typeof window !== 'undefined') ? Object.assign({}, DEFAULT_PHOTOCROMATIC_MAP, window.PHOTOCROMATIC_COLOR_MAP || {}) : DEFAULT_PHOTOCROMATIC_MAP;
            const GLOBAL_COLOR_LABEL = (typeof window !== 'undefined') ? Object.assign({}, DEFAULT_PHOTOCROMATIC_LABEL, window.PHOTOCROMATIC_COLOR_LABEL || {}) : DEFAULT_PHOTOCROMATIC_LABEL;
            let colorHtml = '';
            if (detectedColor) {
              const hex = GLOBAL_COLOR_MAP[detectedColor] || detectedColor;
              const label = GLOBAL_COLOR_LABEL[detectedColor] || (detectedColor.charAt(0).toUpperCase() + detectedColor.slice(1));
              colorHtml = `<span class="addon-color" style="margin-left:8px;display:inline-flex;align-items:center;font-size:12px;color:#333"><span style="width:12px;height:12px;border-radius:50%;display:inline-block;background:${hex};margin-right:6px;box-shadow:0 1px 2px rgba(0,0,0,0.15)"></span>${label}</span>`;
            }
            
            // Determinar si mostrar precio o "Incluido"
            const priceDisplay = addonPrice === 0 ? 
              '<span class="addon-included">Incluido</span>' : 
              `<span class="addon-price">${addonPrice.toFixed(2)} €</span>`;
            
            html += `
              <div class="addon-item">
                <span class="addon-name">${displayName}${colorHtml}</span>
                ${priceDisplay}
              </div>
            `;
          });
          
          html += `</div></div></div>`;
        }

        html += `</div>`;
        groupsHtml.push(html);
      });

      if (groupsHtml.length === 0) {
        // If there are truly no items in the cart, show the empty message and clean up summary/footer
        if (Number(cart?.item_count || 0) === 0) {
          container.innerHTML = `<div class="cart-drawer__empty">Tu carrito está vacío</div>`;

          // Mark dialog as empty (mirrors server-side liquid behavior)
          try {
            const dialog = this.querySelector('.cart-drawer__dialog') || this.querySelector('dialog');
            if (dialog) dialog.classList.add('cart-drawer--empty');
          } catch (e) {}

          // Remove or hide the summary/footer so totals don't persist
          try {
            const summaryEl = this.querySelector('.cart-drawer__summary') || document.querySelector('.cart-drawer__summary');
            if (summaryEl) {
              // remove from DOM to prevent stale totals
              summaryEl.remove();
            }
          } catch (e) {}

          // Dispatch cart update event with zero items so other listeners update (cart icon, sections, etc.)
          try {
            document.dispatchEvent(new CartUpdateEvent({ item_count: 0 }, 'cart-drawer', { itemCount: 0, source: 'cart-drawer' }));
          } catch (e) {}

          return;
        }

        // Fallback: cart reports items but grouping produced no groups (defensive).
        // Render a minimal list of items to avoid showing an incorrect empty state.
        try {
          const fallbackItems = (cart.items || []).map(i => {
            const title = i.product_title || i.title || 'Producto';
            const qty = i.quantity || 1;
            const price = ((i.final_price ?? i.original_price ?? i.price) / 100).toFixed(2);
            return `<div class="grouped-cart-fallback-item"><div class="fallback-title">${title}</div><div class="fallback-meta">Cantidad: ${qty} · ${price} €</div></div>`;
          }).join('');

          container.innerHTML = `<div class="grouped-cart-list">${fallbackItems}</div>`;
          this.injectGroupedStyles();
          // Ensure dialog is not marked empty and summary (if present) remains visible
          try {
            const dialog = this.querySelector('.cart-drawer__dialog') || this.querySelector('dialog');
            if (dialog) dialog.classList.remove('cart-drawer--empty');
            const summaryEl = this.querySelector('.cart-drawer__summary') || document.querySelector('.cart-drawer__summary');
            if (summaryEl) summaryEl.style.display = '';
          } catch (e) {}
        } catch (err) {
          // Last-resort: if fallback fails, show a neutral placeholder (not the empty message)
          container.innerHTML = `<div class="cart-drawer__empty"></div>`;
        }

        return;
      }

      container.innerHTML = `<div class="grouped-cart-list">${groupsHtml.join('')}</div>`;
      this.injectGroupedStyles();

      this.querySelectorAll('.grouped-cart-item__remove').forEach(btn => {
          btn.addEventListener('click', async (e) => {
          const gid = btn.getAttribute('data-group-id');
          const allButtons = Array.from(this.querySelectorAll('.grouped-cart-item__remove'));
          allButtons.forEach(b => b.disabled = true);

          try {
            const confirmed = await this.showConfirm(`¿Eliminar producto y sus configuraciones?`);
            if (!confirmed) return;

            try { this.setContentBlur(true); } catch (err) {}
            this.showLoading();

            const removeResult = await this.removeGroup(gid, cart.items);
            // Prefer render using the fresh cart returned by removeGroup to avoid race conditions
            const freshCart = removeResult?.cart || removeResult || null;
            await this.renderGroupedCart(freshCart);
            // If the change endpoint returned rendered sections, try to update the drawer summary
            const returnedSections = removeResult?.sections || null;
            if (returnedSections) {
              try {
                // Determine the local section id for the drawer summary so we look up the correct key
                const getLocalSectionId = (selector) => {
                  const el = this.querySelector(selector) || document.querySelector(selector);
                  if (!el) return null;
                  const sec = el.closest('[id^="shopify-section-"]');
                  if (!sec) return null;
                  return sec.id.replace(/^shopify-section-/, '');
                };

                const summarySectionId = getLocalSectionId('.cart-drawer__summary') || getLocalSectionId('.cart__summary') || null;
                const summaryHtml = summarySectionId ? returnedSections[summarySectionId] : null;

                // Fallback: if we can't find a matching section id, try common keys
                const fallbackHtml = returnedSections['cart-drawer'] || returnedSections['cart-summary'] || null;

                const htmlToParse = summaryHtml || fallbackHtml;
                if (htmlToParse) {
                  const parsed = new DOMParser().parseFromString(htmlToParse, 'text/html');
                  const newSummary = parsed.querySelector('.cart-drawer__summary') || parsed.querySelector('.cart__summary');
                  const currentSummary = this.querySelector('.cart-drawer__summary') || document.querySelector('.cart-drawer__summary');
                  if (currentSummary && newSummary) currentSummary.innerHTML = newSummary.innerHTML;
                }
              } catch (err) {
                // non-blocking: continue even if summary update fails
                console.warn('Failed to apply returned sections to cart drawer summary', err);
              }
            }

            // Ahora que hemos re-renderizado con el cart fresco, despachar el evento para notificar a otros listeners
            if (freshCart) {
              document.dispatchEvent(new CartUpdateEvent(freshCart, 'cart-drawer', { itemCount: freshCart.item_count, source: 'cart-drawer', sections: returnedSections }));

              // Si la burbuja visible no coincide con el item_count, forzar re-render de la sección del bubble
              try {
                const bubbleCountEl = document.querySelector('.cart-bubble__count, .cart-bubble__text, .cart-bubble-count, .cart-bubble span, [data-cart-count]');
                const visibleCount = bubbleCountEl ? parseInt(bubbleCountEl.textContent || '0', 10) : NaN;
                if (!Number.isNaN(visibleCount) && visibleCount !== freshCart.item_count) {
                  // Intentar detectar section id del bubble y re-renderizarla
                  const bubbleSec = (document.querySelector('.cart-bubble') || document.querySelector('[data-cart-bubble]'))?.closest('[id^="shopify-section-"]');
                  const bubbleSectionId = bubbleSec ? bubbleSec.id.replace(/^shopify-section-/, '') : null;
                  if (bubbleSectionId && window?.sectionRenderer?.renderSection) {
                    window.sectionRenderer.renderSection(bubbleSectionId, { cache: false }).catch(() => {});
                  }
                }
              } catch (e) {
                // no-op
              }
            }
          } catch (err) {
            console.error('Error removing group', err);
          } finally {
            allButtons.forEach(b => b.disabled = false);
            this.hideLoading();
            try { this.setContentBlur(false); } catch (err) {}
          }
        });
      });

    } catch (err) {
      console.error('Error rendering grouped cart drawer:', err);
    }
  }

  injectGroupedStyles() {
    if (this._groupedStylesInjected) return;

    // Nombre del asset que buscamos en head / CDN
    const assetName = 'cart-drawer-grouped.css';

    try {
      // 1) Buscar un <link rel="stylesheet"> que contenga el nombre del asset
      const linkFound = Array.from(document.querySelectorAll('link[rel~="stylesheet"]')).find(l => l.href && l.href.indexOf(assetName) !== -1);
      if (linkFound) {
        this._groupedStylesInjected = true;
        return;
      }

      // 2) Comprobar si alguna stylesheet ya cargada (document.styleSheets) contiene el asset
      const sheetFound = Array.from(document.styleSheets || []).some(s => s.href && s.href.indexOf(assetName) !== -1);
      if (sheetFound) {
        this._groupedStylesInjected = true;
        return;
      }
    } catch (err) {
      // Si el acceso a document.styleSheets lanza por CORS, proseguimos con el fallback
    }

    // Fallback: inyectar estilos inline sólo si no existe la hoja externa
    const style = document.createElement('style');
    style.textContent = `
      .grouped-cart-list { display: flex; flex-direction: column; gap: 1.5rem; padding: 1rem; }
      .grouped-cart-item { border: 1px solid var(--color-border); border-radius: 8px; padding: 1rem; background: var(--color-background); }
      .grouped-cart-item__main { display: flex; gap: .75rem; align-items: flex-start; margin-bottom: 0.75rem; }
      .grouped-cart-item__thumb img { width: 60px; height: 60px; object-fit: cover; border-radius: 6px; }
      .grouped-cart-item__title-wrap { display: flex; flex-direction: column; gap: .25rem; flex: 1; }
      .grouped-cart-item__title { font-weight: 600; font-size: 1rem; line-height: 1.3; }
      .grouped-cart-item__meta { color: rgb(var(--color-foreground-rgb) / .8); font-size: 0.9rem; font-weight: 500; }
      .grouped-cart-item__details { border-top: 1px solid var(--color-border-light); padding-top: 0.75rem; }
      .grouped-cart-item__addons { background: rgb(var(--color-foreground-rgb) / .03); border-radius: 6px; padding: 0.75rem; }
      .addons-title { font-size: 0.85rem; font-weight: 600; color: rgb(var(--color-foreground-rgb) / .8); margin-bottom: 0.5rem; }
      .addons-list { display: flex; flex-direction: column; gap: 0.4rem; }
      .addon-item { display: flex; justify-content: space-between; align-items: center; font-size: 0.8rem; line-height: 1.3; }
      .addon-name { color: rgb(var(--color-foreground-rgb) / .8); font-style: italic; }
      .addon-price { color: rgb(var(--color-foreground-rgb) / .9); font-weight: 500; }
      .addon-included { color: #10b981; font-weight: 500; font-style: italic; font-size: 0.75rem; }
      .grouped-cart-item__remove { background: transparent; border: none; padding: 0.5rem; color: var(--color-foreground); cursor: pointer; flex-shrink: 0; }
      .grouped-cart-item__remove svg { width: 18px; height: 18px; display: block; }
      .grouped-cart-item__remove:hover { opacity: 0.7; }
  .cart-drawer__loading { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgb(var(--color-foreground-rgb) / .03); z-index: 60; pointer-events: none; }
      .cart-drawer__loading .spinner { width: 36px; height: 36px; border-radius: 50%; border: 4px solid rgba(0,0,0,0.08); border-top-color: rgba(0,0,0,0.45); animation: spin 1s linear infinite; pointer-events: auto; }
      .grouped-cart-list--blurred { filter: blur(6px); transition: filter .25s ease; }
      @keyframes spin { to { transform: rotate(360deg); } }
      .cart-drawer__confirm-overlay { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgb(var(--color-foreground-rgb) / .03); z-index: 40; pointer-events: none; }
      .cart-drawer__confirm-box { background: var(--color-background); padding: 1.5rem; border-radius: 8px; box-shadow: 0 6px 18px rgba(0,0,0,0.12); max-width: 360px; width: 90%; pointer-events: auto; }
      .cart-drawer__confirm-text { margin: 0 0 1rem 0; }
      .cart-drawer__confirm-actions { display: flex; gap: .5rem; justify-content: flex-end; margin-top: .75rem }
      .cart-drawer__confirm-cancel { background: transparent; border: 1px solid var(--color-border); padding: .5rem 1rem; border-radius: 4px; cursor: pointer; }
      .cart-drawer__confirm-ok { background: var(--color-button-background); color: var(--color-button-text); border: none; padding: .5rem 1rem; border-radius: 4px; cursor: pointer; }
    `;
    this.appendChild(style);
    this._groupedStylesInjected = true;
  }

  showLoading() {
    if (this._loadingShown) return;
    const overlay = document.createElement('div');
    overlay.className = 'cart-drawer__loading';
    overlay.innerHTML = `<div class="spinner" role="status" aria-label="Cargando"></div>`;
    const inner = this.querySelector('.cart-drawer__content') || this;
    inner.style.position = inner.style.position || 'relative';
    inner.appendChild(overlay);
    this._loadingShown = true;
    this._loadingEl = overlay;
  }

  hideLoading() {
    if (!this._loadingShown) return;
    this._loadingEl?.remove();
    this._loadingShown = false;
    this._loadingEl = null;
    try { this.setContentBlur(false); } catch (e) {}
  }

  setContentBlur(enable) {
    const container = this.querySelector('.cart-drawer__items') || document.querySelector('.cart-drawer__items');
    if (!container) return;
    const grouped = container.querySelector('.grouped-cart-list');
    const target = grouped || container;
    if (enable) target.classList.add('grouped-cart-list--blurred'); 
    else target.classList.remove('grouped-cart-list--blurred');
  }

  async removeGroup(groupId, items = []) {
    const normalizeProps = (item) => {
      if (!item.properties) return {};
      if (Array.isArray(item.properties)) {
        const o = {};
        item.properties.forEach(p => { if (p?.name) o[p.name] = p.value; });
        return o;
      }
      return item.properties || {};
    };

    const linesToRemove = [];
    items.forEach((item, idx) => {
      const props = normalizeProps(item);
      if ((props._p_groupId || item.key) === groupId) {
        linesToRemove.push(idx + 1);
      }
    });

    if (!linesToRemove.length) return;

    const changeUrl = window.Theme?.routes?.cart_change_url || '/cart/change.js';

    // Determine which section IDs we should request from the server so it returns the correct keys
    const detectSectionId = (selector) => {
      const el = document.querySelector(selector) || this.querySelector(selector);
      if (!el) return null;
      const sec = el.closest('[id^="shopify-section-"]');
      if (!sec) return null;
      return sec.id.replace(/^shopify-section-/, '');
    };

    const sectionsToRequest = new Set();
    const summaryId = detectSectionId('.cart-drawer__summary') || detectSectionId('.cart__summary');
    if (summaryId) sectionsToRequest.add(summaryId);
    // cart-bubble might be inside header-actions or header; try common selectors
    const bubbleEl = document.querySelector('.cart-bubble') || document.querySelector('[data-cart-bubble]');
    if (bubbleEl) {
      const bubbleSec = bubbleEl.closest('[id^="shopify-section-"]');
      if (bubbleSec) sectionsToRequest.add(bubbleSec.id.replace(/^shopify-section-/, ''));
    }

    // Fallback to legacy keys if detection failed
    if (sectionsToRequest.size === 0) {
      sectionsToRequest.add('cart-drawer');
      sectionsToRequest.add('cart-icon-bubble');
    }

    // Collect sections returned by change endpoint so we can update summary/footer without extra fetch
    const mergedSections = {};
    const sectionsParam = Array.from(sectionsToRequest).join(',');
    for (const line of linesToRemove.sort((a,b) => b - a)) {
      const body = JSON.stringify({ 
        line, 
        quantity: 0, 
        sections: sectionsParam,
        sections_url: window.location.pathname 
      });
      try {
        const resp = await fetch(changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
        if (resp && resp.ok) {
          const text = await resp.text();
          try {
            const parsed = JSON.parse(text);
            if (parsed?.sections && typeof parsed.sections === 'object') {
              Object.assign(mergedSections, parsed.sections);
            }
          } catch (e) {
            // ignore parse errors for individual change calls
          }
        }
      } catch (e) {
        // ignore individual errors
      }
    }

    try {
      const fresh = await fetch('/cart.js', { 
        cache: 'no-store', 
        headers: { 'Accept': 'application/json' } 
      });
      if (fresh.ok) {
        const freshCart = await fresh.json();
        // Devolver cart actualizado y las secciones colectadas de las respuestas de change.js
        return { cart: freshCart, sections: Object.keys(mergedSections).length ? mergedSections : null };
      }
    } catch (e) {}
    return null;
  }

  ensureConfirmDialog() {
    // Si ya existe y está conectado al DOM, reutilizarlo
    if (this._confirmDialog && this._confirmDialog.isConnected) return this._confirmDialog;

    // Si existe pero se ha desconectado (fue removido por un re-render), limpiarla para recrearla
    if (this._confirmDialog && !this._confirmDialog.isConnected) {
      try { this._confirmDialog.remove(); } catch (e) {}
      this._confirmDialog = null;
    }

    // Crear el overlay/diálogo de confirmación
    const overlay = document.createElement('div');
    overlay.className = 'cart-drawer__confirm-overlay';
    overlay.innerHTML = `
      <div class="cart-drawer__confirm-box">
        <p class="cart-drawer__confirm-text">¿Eliminar este producto y sus configuraciones?</p>
        <div class="cart-drawer__confirm-actions">
          <button class="cart-drawer__confirm-cancel">Cancelar</button>
          <button class="cart-drawer__confirm-ok button">Eliminar</button>
        </div>
      </div>
    `;

    const inner = this.querySelector('.cart-drawer__content') || this;
    inner.style.position = inner.style.position || 'relative';
    inner.appendChild(overlay);
    overlay.style.display = 'none';
    this._confirmDialog = overlay;
    return overlay;
  }

  showConfirm(message) {
    return new Promise((resolve) => {
      const overlay = this.ensureConfirmDialog();
      const text = overlay.querySelector('.cart-drawer__confirm-text');
      if (text) text.textContent = message || text.textContent;

      const btnOk = overlay.querySelector('.cart-drawer__confirm-ok');
      const btnCancel = overlay.querySelector('.cart-drawer__confirm-cancel');

      try { this.setContentBlur(true); } catch (e) {}

      const cleanup = () => {
        overlay.style.display = 'none';
        btnOk.removeEventListener('click', onOk);
        btnCancel.removeEventListener('click', onCancel);
      };

      const onOk = (e) => { 
        e.preventDefault(); 
        cleanup(); 
        resolve(true); 
      };
      
      const onCancel = (e) => { 
        e.preventDefault(); 
        cleanup(); 
        try { this.setContentBlur(false); } catch (err) {} 
        resolve(false); 
      };

      btnOk.addEventListener('click', onOk);
      btnCancel.addEventListener('click', onCancel);

      overlay.addEventListener('click', (ev) => {
        if (ev.target === overlay) { 
          cleanup(); 
          try { this.setContentBlur(false); } catch (err) {} 
          resolve(false); 
        }
      }, { once: true });

      overlay.style.display = 'flex';
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}